


import request from '@/util/axios'

//tag 获取用户是否绑定提现
export const getTxType = data => {
  return request({
    url: `/store/SellerAdmin/Home/QueryRoleAccountConfigIsSet`,
    method: 'post',
    data
  })
}


//tag 商家端登录图片校验
export const getImgCode = data => {
    return request({
      url: `/store/Login/GetCheckCode`,
      method: 'post',
      data
    })
}
//获取用户信息
export const getUserRules = params => {
  return request({
    url: `/store/selleradmin/SellerPublic/UserManager`,
    method: 'get',
    params
  })
}


//核销码验证
export const ruleCode = data => {
  return request({
    url: `/store/SellerAdmin/Order/ObtainOrder`,
    method: 'post',
    data
  })
}
//控制台首页数据
export const getSellerHome = data => {
  return request({
    url: `/store/SellerAdmin/Home/QueryHomeDataStatistics`,
    method: 'post',
    data
  })
}
//查询提现基础数据
export const getTxBase = data => {
  return request({
    url: `/store/SellerAdmin/Home/QueryRoleAccountInfo`,
    method: 'post',
    data
  })
}
//获取个人授权二维码
export const getUserCode = data => {
  return request({
    url: `/store/SellerAdmin/Home/QueryAuthorizationPath`,
    method: 'post',
    data
  })
}
//更新提现绑定
export const uplodeTxBase = data => {
  return request({
    url: `/store/SellerAdmin/Home/DealRoleAccountInfo`,
    method: 'post',
    data
  })
}
//获取个人是否扫码授权完成了
export const getStatus = data => {
  return request({
    url: `/store/SellerAdmin/Home/QueryRoleAccountIsAuthorization`,
    method: 'post',
    data
  })
}



//查询市场方的商家列表
export const QueryMarketsShop  = data => {
  return request({
    url: `/store/SellerAdmin/SettlementPlugins/QueryMarketsShop`,
    method: 'post',
    data
  })
}

//查询合伙人 供应商 物流 是否设置了分账配置
export const allocationAccounts  = data => {
  return request({
    url: `/store/SellerAdmin/SettlementPlugins/QueryFashionableSubAccountConfigIsSet`,
    method: 'post',
    data
  })
}

//查询合伙人 供应商 物流 分帐方配置查询
export const getFashionableSubAccount  = data => {
  return request({
    url: `/store/SellerAdmin/SettlementPlugins/GetFashionableSubAccount`,
    method: 'post',
    data
  })
}

//查询合伙人 供应商 物流 分帐方配置 新建编辑
export const SaveAccount  = data => {
  return request({
    url: `/store/SellerAdmin/SettlementPlugins/SaveFashionableSubAccount`,
    method: 'post',
    data
  })
}






